// extracted by mini-css-extract-plugin
export default {"paperStyle":"Login_paperStyle__Nk+FK","headerStyle":"Login_headerStyle__gVWKf","avatarStyle":"Login_avatarStyle__vkh7L","formStyle":"Login_formStyle__4fF0e"};